module.exports = __webpack_public_path__ + "lastladyjane.jpg?821f30a339d86624a68bd64b92d7c0ba";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/lastladyjane.jpg
// module id = 674
// module chunks = 0